import { getSupabaseClient } from './supabase.client.js';

/**
 * Repositorio de gift cards (migración 35, spec staff-giftcards). Todo pasa
 * por RPCs: el staff nunca lee la tabla (RLS admin-only) y los estados y
 * totales los calcula SQL. Una sesión sin el rol pedido recibe 42501, que se
 * propaga como error con `code`.
 */

/** @param {{ message: string, code?: string }} error @returns {never} */
function rethrow(error) {
    const err = new Error(error.message);
    if (error.code) err.code = error.code;
    throw err;
}

/**
 * @param {string} name
 * @param {Record<string, unknown>} [args]
 */
async function rpc(name, args) {
    const client = getSupabaseClient();
    if (!client) throw new Error('Supabase no configurado');
    const { data, error } = await client.rpc(name, args);
    if (error) rethrow(error);
    return data;
}

/**
 * @param {{ monto: number, medio: string, para: string, deParte: string | null, mensaje: string | null }} params
 * @returns {Promise<{ ok: boolean, error?: string, giftcard?: Record<string, any> }>}
 */
export function emitirGiftcard({ monto, medio, para, deParte, mensaje }) {
    return rpc('emitir_giftcard', { p_monto: monto, p_medio: medio, p_para: para, p_de_parte: deParte, p_mensaje: mensaje });
}

/** @returns {Promise<Array<{ id: string, para: string, de_parte: string | null, monto: number, emitida_at: string, valida_hasta: string }>>} */
export async function listarVigentes() {
    return (await rpc('listar_giftcards_vigentes')) ?? [];
}

/** @param {string} id @returns {Promise<{ ok: boolean, error?: string }>} */
export function canjearGiftcard(id) {
    return rpc('canjear_giftcard', { p_id: id });
}

/**
 * @param {'vigentes'|'canjeadas'|'vencidas'|'anuladas'} estado
 * @returns {Promise<{ ok: boolean, error?: string, items?: Array<Record<string, any>>, totales?: Record<string, { cantidad: number, monto: number }> }>}
 */
export function listarGiftcards(estado) {
    return rpc('listar_giftcards', { p_estado: estado });
}

/** @param {{ id: string, motivo: string }} params @returns {Promise<{ ok: boolean, error?: string }>} */
export function anularGiftcard({ id, motivo }) {
    return rpc('anular_giftcard', { p_id: id, p_motivo: motivo });
}
